import { pick } from 'lodash'
import { track } from '../analytics'

const getArgs = args => pick(args, ['workspaceId', 'workspaceSlug'])

export const personasViewedDestinations = args => {
  track('Personas Viewed Destinations', getArgs(args))
}

export const personasClickedConnectDestination = args => {
  track('Personas Clicked Connect Destination', getArgs(args))
}

export const personasClickedSetupDestination = args => {
  track('Personas Clicked Setup Destination', getArgs(args))
}

export const personasConnectedDestinations = args => {
  track('Personas Connected Destinations', {
    ...getArgs(args),
    destinations: args.destinations
  })
}

export const personasToggledImportDestination = args => {
  track('Personas Toggled Import Destination', {
    ...getArgs(args),
    destination: args.destination
  })
}
